module.exports = __webpack_public_path__ + "57a2dedcd8decce369b56a93fe755cf3.svg";